// extracted by mini-css-extract-plugin
export default {"container":"Heroe_container__9T1Ns","overlay":"Heroe_overlay__XsdIQ","head":"Heroe_head__zPBtT","texts":"Heroe_texts__3sD8Y","joinus":"Heroe_joinus__MaF2u"};